import { Button, Typography } from "@mui/material";
import Box from "@mui/material/Box";

const NotFound = () => {
	return (
		<>
			<Box style={{height: '90vh', alignContent: 'center', justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
				<Box style={{alignSelf: 'center', textAlign: 'center'}}>
					<Typography variant={"h1"} component={"h1"} align={"center"}>
						🙁
					</Typography>
					<Typography variant={"h2"} component={"h2"} align={"center"}>
						Erro 404
					</Typography>
					<Typography variant={"h3"} component={"h3"} align={"center"}>
						Conteúdo não encontrado
					</Typography>
					<Button href={"/"} style={{textAlign: 'center', alignSelf: 'center'}} variant={"outlined"}>
						Início
					</Button>
				</Box>
			</Box>
		</>
	)
};

export default NotFound;